import styled from 'styled-components';
import { Dropdown } from '../../Dropdown';
import { DropdownContentContainer } from '../../DropdownContentContainer';
import { IconSelectInput } from '../../baseInputs/IconSelectInput';
import { NumberInput } from '../../baseInputs/NumberInput';
import { BackgroundInput } from '../styleProps/containerComboInput/BackgroundInput';
import { useScene } from '../../../../context/sceneContext';

export const OverflowInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData(
    {
      overflow: undefined,
      ['&::-webkit-scrollbar']: undefined,
      ['&::-webkit-scrollbar-track']: undefined,
      ['&::-webkit-scrollbar-thumb']: undefined,
    },
    'props.class'
  );

  return (
    <Row>
      <IconSelectInput
        label="Overflow"
        value={data.overflow}
        defaultValue="visible"
        data={[
          {
            value: 'visible',
            iconClassName: 'icon-text-none',
            id: 'overflow-visible',
            tooltip: 'Visible',
          },
          {
            value: 'hidden',
            iconClassName: 'icon-notvisible',
            id: 'overflow-hidden',
            tooltip: 'Hidden',
          },
          {
            value: 'auto',
            iconClassName: 'icon-scroll',
            id: 'overflow-auto-scroll',
            tooltip: 'Auto Scroll',
          },
        ]}
        onChange={(newValue) =>
          scene.updateSelectedElementsData(
            {
              overflow: newValue,
              overflowX: newValue === 'auto' && 'hidden',
              ...(newValue !== 'hidden' && { textOverflow: undefined }),
            },
            'props.class',
            'overflowInput'
          )
        }
        style={{
          width: '100%',
          paddingLeft: '8px',
          justifyContent: 'space-between',
        }}
      />

      <Dropdown
        trigger={
          <DropdownButton>
            <i className="icon-triple-dots" />
          </DropdownButton>
        }
        style={{
          width: '16px',
          height: '24px',
        }}
        contentStyle={{ width: '200px' }}
        horizontalAlign="left"
        closeOnClick={false}
      >
        <DropdownContentContainer>
          <Title>Scrollbar</Title>
          <Row>
            <NumberInput
              label="Size"
              value={data['&::-webkit-scrollbar']?.width}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    ['&::-webkit-scrollbar.width']: newValue,
                    ['&::-webkit-scrollbar.height']: newValue,
                  },
                  'props.class',
                  'overflowInput'
                )
              }
              defaultUnit="px"
              minValue={0}
              inputStyle={{ textAlign: 'center' }}
            />
            <NumberInput
              iconClassName="icon-radius"
              id={'window-scrollbar-radius-input'}
              tooltip="Scrollbar Radius"
              value={data['&::-webkit-scrollbar-track']?.borderRadius}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    ['&::-webkit-scrollbar-track.borderRadius']: newValue,
                    ['&::-webkit-scrollbar-thumb.borderRadius']: newValue,
                  },
                  'props.class',
                  'overflowInput'
                )
              }
              defaultUnit="px"
              minValue={0}
              inputStyle={{ textAlign: 'center' }}
            />
          </Row>
          <Row>
            <Label style={{ paddingLeft: '8px' }}>Track</Label>
          </Row>
          <Row>
            <BackgroundInput
              value={data['&::-webkit-scrollbar-track']?.backgroundColor}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    ['&::-webkit-scrollbar-track.backgroundColor']: newValue,
                  },
                  'props.class',
                  'overflowInput'
                )
              }
              onlySolid
            />
          </Row>
          <Row>
            <Label style={{ paddingLeft: '8px' }}>Thumb</Label>
          </Row>
          <Row>
            <BackgroundInput
              value={data['&::-webkit-scrollbar-thumb']?.backgroundColor}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  { ['&::-webkit-scrollbar-thumb.backgroundColor']: newValue },
                  'props.class',
                  'overflowInput'
                )
              }
              onlySolid
            />
          </Row>
        </DropdownContentContainer>
      </Dropdown>
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;

  gap: 5px;
`;

const DropdownButton = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 5px;

  & > i {
    rotate: 90deg;
    font-size: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  transition:
    background-color 0.2s,
    color 0.2s;
  &:hover {
    background-color: var(--neutral-3);
    color: var(--main-1);
  }
`;

const Title = styled.div`
  text-align: center;
  font-size: 12px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid var(--neutral-3);
`;

const Label = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin: 5px 0;

  font-size: 11px;

  display: flex;
  align-items: center;
  gap: 15px;
`;
